export default __webpack_public_path__ + "static/media/ep4-shelf-bg.b917f156.jpg";